import React, { useState, useEffect } from "react"
import Stepper from "react-stepper-horizontal"
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    CardText,
    CardImg,
    Input,
    Label,
    Row,
    Spinner,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    CardFooter,
    CardHeader
} from "reactstrap"

import BreadCrumb from "../Components/BreadCrumb"
import { useWallet } from "../libs/useMetaMaskWallet"
import { api } from "../apis/validatenft/api"
import { useToast } from "../hooks/toast"
import sample_ick from "../assets/images/communityKey/ick_sample.jpg"

const ValidateCommunityNFT = () => {
    const wallet = useWallet()
    const toast = useToast()
    const premintDefault = {
        telegram_nftkey_fantom: false,
        twitter_nftkey_fantom: false
    }

    const [data, setData] = useState({
        premint: false,
        queue: false,
        minted: false,
        validated: false,
        accepted: false,
        tokenId: -1,
        name: "Idexo Community Key",
        description: "NFT key to community competition",
        image: "https://ipfs.io/ipfs/QmUnnnfze5G5DuE2ddRc1o3UEsEAMUjPbGBRnJ38CPwHAV"
    })

    const [steps, setSteps] = useState([{ title: "Validate" }, { title: "Accept Terms" }, { title: "Request NFT" }])

    const [currentStep, setCurrentStep] = useState(0)

    const [processing, setProcessing] = useState(false)
    const [showTerms, setShowTerms] = useState(false)
    const [showProcessing, setShowProcessing] = useState(false)

    const [premint, setPremint] = useState(premintDefault)
    const [loading, setLoading] = useState(true)

    const handleClose = (type) => {
        switch (type) {
            case "terms":
                setShowTerms(false)
                break
            case "process":
                setShowProcessing(false)
                break

            default:
                break
        }
    }

    const handleOpen = (type) => {
        switch (type) {
            case "terms":
                setShowTerms(true)
                break
            case "process":
                setShowProcessing(true)
                break

            default:
                break
        }
    }

    const handleData = (key, value) => {
        data[key] = value
        setData({ ...data })
    }
    const handlePremint = (key, value) => {
        premint[key] = value
        setPremint({ ...premint })
    }

    const onSubmit = async () => {
        setProcessing(true)
        let response = await api.changePending(wallet.account)
        if (response) {
            setShowProcessing(true)
            handleData("queue", true)
            toast.addSuccess("Your request has been processed")
        } else {
            toast.addError("An error has occurred")
        }
        setProcessing(false)
    }

    useEffect(() => {
        if (!data.validated) {
            setCurrentStep(0)
        }
        if (data.validated && !data.accepted) {
            setCurrentStep(1)
        }
        if (data.validated && data.premint && data.accepted) {
            setCurrentStep(2)
        }
        return () => {}
    }, [data.premint, data.validated, data.accepted])

    useEffect(() => {
        if (premint.telegram_nftkey_fantom && premint.twitter_nftkey_fantom) {
            handleData("premint", true)
        } else {
            handleData("premint", false)
        }
        return () => {}
    }, [premint])

    useEffect(() => {
        setLoading(true)
        const checkNft = async (wallet) => {
            if (wallet) {
                let response = await api.getNft(wallet)
                if (response) {
                    let data = response.data?.Items
                    if (data?.length > 0) {
                        let step = data[0].step.S
                        if (step === "done") {
                            let tokenUri = data[0].token_uri.S
                            const uri = await fetch(tokenUri)
                            const tokenUriJson = await uri.json()
                            handleData("minted", true)
                            handleData("tokenId", data[0].token_id.N)
                            handleData("name", tokenUriJson.name)
                            handleData("description", tokenUriJson.description)
                            handleData("image", tokenUriJson.image)
                        }
                    } else {
                        checkPremint(wallet)
                    }
                }
            }
            setLoading(false)
        }

        const checkPremint = async (wallet) => {
            if (wallet) {
                let response = await api.getPending(wallet)
                if (response) {
                    let data = response.data?.Items
                    if (data?.length > 0) {
                        let step = data[0].step.S
                        if (step === "accepted" || step === "ready") {
                            handleData("queue", true)
                        } else {
                            handleData("queue", false)
                        }
                        for (let i = 0; i < data.length; i++) {
                            handlePremint(`${data[i].source.S}`, true)
                        }
                    } else {
                        setPremint(premintDefault)
                    }
                }
            }
            setLoading(false)
        }

        if (!data.minted) {
            checkNft(wallet.account)
        }
        setLoading(false)
    }, [wallet.account])

    const stepsComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <Stepper
                            size={46}
                            completeColor={"#34c38f"}
                            completeTitleOpacity={"0.5"}
                            activeColor={"#f95936"}
                            steps={steps}
                            activeStep={currentStep}
                        />
                    </Card>
                </Col>
            </Row>
        )
    }

    const queueComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <Row>
                            <Col sm="6">
                                <Card className="text-center m-3">
                                    <CardBody>
                                        <CardTitle className="h3">Idexo Community Key NFT</CardTitle>
                                        <CardText>
                                            Earn 500 CRED by {<a href="/tasks">completing some tasks</a>} to prove your Idexonaut status and receive
                                            your NFT.
                                        </CardText>
                                        <CardBody>
                                            <CardImg src={sample_ick} />
                                        </CardBody>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        )
    }

    const nftComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <Row>
                            <Col sm="6">
                                <Card className="text-center m-3">
                                    <CardBody>
                                        <CardTitle className="h3">Idexo Community Key NFT</CardTitle>

                                        <CardImg width="100%" src={data.image}></CardImg>
                                        <CardFooter>
                                            <CardText>{data.name}</CardText>
                                            <CardText> {data.description}</CardText>
                                        </CardFooter>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        )
    }

    const validateComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="h3">Validate Pre Mint</CardTitle>
                            <CardText>To continue you must pre mint on Telegram and Twitter</CardText>
                            <CardBody>
                                <CardText>
                                    <Input
                                        type="checkbox"
                                        disabled={true}
                                        name="telegram_nftkey_fantom"
                                        id="telegram_nftkey_fantom"
                                        checked={premint.telegram_nftkey_fantom}
                                        className="me-2"
                                        onClick={(e) => handlePremint("telegram_nftkey_fantom", e.target.checked)}
                                    />
                                    <Label htmlFor="telegram_nftkey_fantom">Telegram Premint</Label>
                                </CardText>
                                <CardText>
                                    <Input
                                        type="checkbox"
                                        disabled={true}
                                        name="twitter_nftkey_fantom"
                                        id="twitter_nftkey_fantom"
                                        checked={premint.twitter_nftkey_fantom}
                                        className="me-2"
                                        onClick={(e) => handlePremint("twitter_nftkey_fantom", e.target.checked)}
                                    />
                                    <Label htmlFor="twitter_nftkey_fantom">Twitter Premint</Label>
                                </CardText>
                            </CardBody>

                            <CardFooter className="text-center">
                                <div className="flex justify-content-end">
                                    <Button
                                        color="primary"
                                        className="waves-effect w-xl btn-submit"
                                        disabled={!data.premint && !data.validated}
                                        onClick={() => handleData("validated", true)}
                                    >
                                        Validate Pre Mint
                                    </Button>
                                </div>
                            </CardFooter>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }

    const acceptComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="h3">Accept The Terms</CardTitle>
                            <CardText>To continue you must agree to the community idexo terms...</CardText>
                            <CardBody>
                                <CardFooter className="text-center">
                                    <div className="flex justify-content-end">
                                        <Button color="primary" className="waves-effect w-xl btn-submit" onClick={() => handleOpen("terms")}>
                                            View Terms
                                        </Button>
                                    </div>
                                </CardFooter>
                            </CardBody>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }

    const mintComponent = () => {
        return (
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="h3">Request your NFT</CardTitle>
                            <CardText>Now you can request your NFT</CardText>
                            <CardFooter className="text-center">
                                <div className="flex justify-content-end">
                                    <Button
                                        color="primary"
                                        className="waves-effect w-xl btn-submit"
                                        disabled={(!data.premint && !data.accepted) || data.minted}
                                        onClick={onSubmit}
                                    >
                                        {processing ? (
                                            <React.Fragment>
                                                REQUESTING NFT..
                                                <Spinner
                                                    style={{
                                                        width: "0.7rem",
                                                        height: "0.7rem",
                                                        marginLeft: "1rem"
                                                    }}
                                                    color="light"
                                                />
                                            </React.Fragment>
                                        ) : (
                                            "REQUEST NFT"
                                        )}
                                    </Button>
                                </div>
                            </CardFooter>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }

    return (
        <React.Fragment>
            <div className="content integrate-nfts">
                <BreadCrumb current="Validate Community NFT" />

                {!loading
                    ? data.minted
                        ? nftComponent()
                        : data.queue
                          ? queueComponent()
                          : !data.minted && !data.queue
                            ? stepsComponent()
                            : null
                    : null}
                {!loading ? (
                    !data.minted && !data.queue && !data.validated && currentStep === 0 ? (
                        validateComponent()
                    ) : !data.minted && !data.queue && currentStep === 1 ? (
                        acceptComponent()
                    ) : !data.minted && !data.queue && currentStep === 2 ? (
                        mintComponent()
                    ) : null
                ) : (
                    <Modal isOpen={true} centered={true}>
                        <ModalHeader tag="h2">Loading...</ModalHeader>
                        <ModalBody className="text-center">
                            <Spinner
                                style={{
                                    width: "50px",
                                    height: "50px"
                                }}
                                color="dark"
                            />
                        </ModalBody>
                    </Modal>
                )}
            </div>

            <Modal className="image-crop-modal" isOpen={showTerms} onClose={() => handleClose("terms")} fade={true} centered={true}>
                <ModalHeader toggle={handleClose}>IDEXO COMMUNITY TERMS OF SERVICE</ModalHeader>
                <ModalBody>
                    <h3>BY COMPLETING THIS COMMUNITY KEY NFT MINT YOU ACKNOWLEDGE THE FOLLOWING:</h3>
                    <p>● This NFT is NOT AN AIRDROP </p>
                    <p>
                        ● Minting this NFT provides you with a tracker for your community activities in supporting idexo and unlocks various benefits
                        you can obtain as a supporter (i.e. as an Idexonaut)
                    </p>
                    <p>● THE PURPOSE OF MINTING THIS NFT IS NOT TO RESELL IT</p>
                    <h3>BY JOINING THE IDEXONAUT COMMUNITY YOU AGREE TO THE FOLLOWING COMMUNITY GUIDELINES</h3>
                    <p>● As an Idexonaut you commit to positive commentary that supports rather than denigrates the project </p>
                    <p>
                        ● Criticism and/or suggestions that are new or different are welcome, provided that they are issued in a non-derogatory or
                        trolling way
                    </p>
                    <p>
                        ● You acknowledge that failure to follow these guidelines can lead to your ability to comment in groups to be suspended and if
                        continued, eventually removed
                    </p>
                </ModalBody>
                <ModalBody style={{ color: "red" }}>Do you agree with the terms of the idexo community?</ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            handleData("accepted", false)
                            handleClose("terms")
                        }}
                    >
                        Not Accept
                    </Button>
                    <Button
                        onClick={() => {
                            handleData("accepted", true)
                            handleClose("terms")
                        }}
                    >
                        Accept
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal className="image-crop-modal" isOpen={showProcessing} onClose={() => handleClose("process")} fade={true} centered={true}>
                <ModalHeader toggle={handleClose}>Processing request</ModalHeader>
                <ModalBody>Your request is being processed...</ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            handleClose("process")
                        }}
                    >
                        Ok
                    </Button>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    )
}

export default ValidateCommunityNFT
